var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VcLayout',{staticClass:"px-4 menu-item__container"},[_c('VcIcon',{staticClass:"menu-item__icon",attrs:{"small":""}},[_vm._v(_vm._s(_vm.item.icon))]),_c('span',{staticClass:"prompt-item-label"},[_vm._v(_vm._s(_vm.item.prompt.title))]),(!!_vm.item.rightIcon)?_c('VcIcon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.item.rightIcon))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }